import { MailToHyperlink } from '@strata/react-hyperlink';

import { Overview } from 'components/shared/Overview';
import { Section } from 'components/shared/Section';

const designsystemOverview = [
    <div key="1">
        <p>
            A design system is a collection of reusable assets such as components, patterns,
            guidance, and code. By using the assets of the Strata Design System, efficiency in
            designing and coding is greatly increased. Rather than focusing on pixels, engineers can
            focus on application logic, while designers can focus on the user experience,
            interactions, and flows. Enhancing the specialty pharmacy system for the benefit of
            pharmacies, payers and patients.
        </p>
        <h4 className="margin__top--large">
            For questions related to the design system please reach out to:
        </h4>
        <MailToHyperlink
            linkText="Design System Team"
            subject="Design System Question"
            emailAddress="strata@freemarkethealth.com"
        />
    </div>,
];

export const DesignSystemOverview = () => (
    <Overview
        title="Strata Design System Overview"
        description="The Strata Design System consists of resources to create user interfaces consistent with our principles, design language, and best practices."
        image="https://sseasacdn.blob.core.windows.net/strata-website/design-system-overview.svg"
        content={
            <Section
                title="What is the Strata Design System?"
                contentArray={designsystemOverview}
            />
        }
    />
);
